export function cleanSource (source) {
  // using native JSON functions removes reactivity
  // so we can clone an object without mutating the original source
  return JSON.parse(JSON.stringify(source));
}

let _scrollPos = 0;

function getScrollBarWidth () {
  return window.innerWidth - document.documentElement.offsetWidth;
}

export function getScrollTop () {
  return window.pageYOffset || document.documentElement.scrollTop;
}

export function setScrollTop (position) {
  document.documentElement.scrollTop = document.body.scrollTop = position;
}

export function addNoScroll (setScrollTo = null) {
  // Store the current Y scroll position
  let scrollBarWidth = getScrollBarWidth();

  _scrollPos = getScrollTop();

  if (typeof setScrollTo === 'number') setScrollTop(setScrollTo);

  document.documentElement.classList.add('has-no-scroll');
  document.body.style.paddingRight =  scrollBarWidth + 'px';
  select('.c-navbar').style.paddingRight =  scrollBarWidth + 'px';
}

export function removeNoScroll () {
  document.documentElement.classList.remove('has-no-scroll');
  document.body.style.paddingRight = '';
  select('.c-navbar').style.paddingRight = '';

  // Reapply the current Y scroll position
  // This is done because the addNoScroll function sets a class on document body which
  // causes the scrollTop to become 0
  setScrollTop(_scrollPos);
}

export function watchScroll ({ minScroll: minScroll } = { minScroll: 65 }) {
  this.scrollingDown = false;
  this.scrollPos = 0;
  this.lastScrollPos = 0;

  let scroller = (e) => {
    this.scrollPos = window.scrollY || document.documentElement.scrollTop;

    // Block updating scroller if position hasn't changed
    if (this.lastScrollPos === this.scrollPos) return;

    if (this.scrollPos > minScroll) {
      this.scrollingDown = (this.scrollPos > this.lastScrollPos && this.scrollPos > 0) ? true : false;

      this.lastScrollPos = this.scrollPos;

      return this.scrollingDown;
    }

    return this.scrollingDown = false;
  };

  window.addEventListener('scroll', scroller);
}


// Used with elementIsRendered
function waitUntil (selector, scope, resolve, reject) {
  let loopCount = 0;
  let maxLoops = 100;

  // Loops until element exists in DOM or loop times out
  function checkForElement () {
    if (loopCount === maxLoops) {
      loopCount = 0;
      return reject('Timed out waiting for element to render');
   }

    let el = select(selector, scope);

    setTimeout(() => {
      if (el) {
        loopCount = 0;
        return resolve(el);
      } else {
        loopCount++;
        checkForElement();
      }
    }, 100);
  };

  checkForElement();
}

// Returns a resolved Promise once the selector returns an element
// Useful for when we need to perform an action only when an element is in the DOM
export function elementIsRendered (selector, scope = document) {
  return new Promise((resolve, reject) => {
    //start the loop
    return waitUntil(selector, scope, resolve, reject);
  });
};

export function wrapWithTag (tag, str, attrs = '') {
  if ((tag && typeof tag === 'string') && (str && typeof str === 'string')) {
    let tagBegin = attrs.length > 0 ? `${ tag } ${ attrs }` : tag;

    return `<${ tagBegin }>${ str }</${ tag }>`;
  } else {
    return '';
  }
}

export function capitalize (str) {
  if (str && typeof str === 'string') {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

export function capitalizeEachWord (string) {
  if (string && typeof string === 'string') {
    let arr = string.split(' ');

    arr = arr.map(el => el.charAt(0).toUpperCase() + el.slice(1))

    return arr.join(' ');
  }
}

export function pluralize (noun, count = 2, suffix = 's') {
  if (noun && typeof noun === 'string') {
    return `${noun}${count !== 1 ? suffix : ''}`;
  }
}

export function limitStr (str, limit = 160) {
  if (typeof str === 'string' && str.length > limit) {
    str = str.slice(0, limit) + '...';
  }

  return str;
}

export function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  let results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export function stripUrlScheme (url) {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
}

// Generates a random integer between min & max
export function randomNum (min, max, decimals = 2) {
  let random = Math.random() * (max - min) + min;

  return parseFloat(random.toFixed(decimals));
}

// Generates a random integer between min & max
export function randomInt (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Returns if a value is an object
export function isObject (value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

// DOM Helpers
export function select (s, scope = document) { return scope.querySelector(s) };
export function selectAll (s, scope = document) { return scope.querySelectorAll(s) };

// Uses GSAP ScrollToPlugin via CDN
// GSAP is registered globally via CDN
export function scrollToSelector (selector, scrollTarget = window) {
  TweenLite.to(scrollTarget, 0.8, { scrollTo: { y: select(selector), autoKill: false }, ease: Power2.easeOut });
}

// Taken from Underscore.js

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce (func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// Returns a function, that, as long as it continues to be invoked, will only
// trigger every N milliseconds. If immediate is passed, trigger the
// function on the leading edge, instead of the trailing.
export function throttle(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    if ( !timeout ) timeout = setTimeout( later, wait );
    if (callNow) func.apply(context, args);
  };
};


// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities.js